import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import Widgets from "./Widgets";
import Dashchart from "./Dashchart";
import Dashtable from "./Dashtable";

const Dashboard = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Dashboard" pageType="Sliced" />
      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <Widgets />
        <Dashchart />
        <Dashtable />
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
